import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    CircularProgress, LinearProgress,
    Dialog, DialogActions, DialogTitle,
    Divider,
    Grid,
    Icon,
    TextField
} from '@material-ui/core';
import SearchBar from 'material-ui-search-bar';
import WarningIcon from '@material-ui/icons/Warning';

import DatasetList from './DatasetList'
//import DatasetList from '../components/DatasetList';
//import Uploader from '../components/Uploader';

import * as FS from 'file-saver';

const styles = theme => ({
    root: {
        position: 'absolute',
        backgroundColor: theme.palette.secondary.main,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
    },
    dataList: {
        maxHeight: '10rem',
        overflow: 'auto'
    },
    deets: {
        fontSize: '.75rem',
    },
    error: {
        color: '#F44336',
        display: 'flex',
        fontSize: '.75em',
        alignItems: 'center',
        '& div': {
            paddingLeft: '.75em',
        }
    },
    uploadSuccess: {
        animation: 'fadeIn 2s forwards',
        textAlign: 'center',
        color: '#4CAF50',
        fontWeight: 500,
        fontSize: '.8em',
    },
    '@keyframes fadeIn': {
        'from': { opacity: 0 },
        'to': { opacity: 1 },
    }
});

export default class Datasets extends React.Component {
    

    constructor(props) {
        super(props);
        //const { classes } = props;
        this.classes = withStyles();
        this.state = { filteredList: [], 
            datasetTitle: "", dialogOpen: false, deletingID: null,
        };
        this.uploader = null;
    }
    componentWillMount() {
        //console.log(this.state.filteredList);
    }
    componentDidMount() {
        
        /*if (this.props.datasets == null && !this.props.fetching) {
            this.props.dispatch(CmsActions.requestDatasets(this.props.userId));
        } else */if (this.state.filteredList != this.props.datasets) {
            this.setState({ filteredList: this.props.datasets });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleting == false) {
            this.handleDeleteClose();
        }

        //if (this.props.fetching && !nextProps.fetching) {
        //    this.props.dispatch(CmsActions.requestVisLayers(this.props.userId));
        //}

        this.setState({ filteredList: nextProps.datasets });
    }
    handleTextFieldChange(evt) {
        this.setState({
            datasetTitle: evt.target.value
        });
    }
    handleGotFile(type, filename) {
        this.setState({ type, valid: true, datasetTitle:filename.substr(0, filename.lastIndexOf('.')) || filename});
    }
    handleCancelFile() {
        this.props.dispatch(CmsActions.dismissError());
        this.setState({ type: null, valid: false, uploadSuccess: false, editedFile: false });
    }
    handleUploadClick(evt) {
        console.log(this.uploader.state.file);
        //this.props.dispatch(CmsActions.uploadDataset(this.props.userId, this.state.datasetTitle, this.uploader.state.file));
    }
    handleEditClick(evt) {
        console.log('yo');
        console.log(this.uploader.state.file)
        //this.props.dispatch(GlobeActions.uploadSitesFile(this.uploader.state.file));
        //this.props.dispatch(CmsActions.uploadDataset(this.props.userId, "SitesCSV", this.uploader.state.file));
        //this.props.dispatch(CmsActions.uploadDataset(this.props.userId, this.state.datasetTitle, this.uploader.state.file));
    }

    handleSelect(id) {
        var dataset = this.state.filteredList.find(x => x.Id === id);
        /*let metaObj = dataset.Meta;
        console.log(metaObj);*/
        console.log(dataset);
        //TODO: push this into some kind of meta rendering component based on all fields, 
        //      maybe converting known types/fields etc? yuck     
        /*let metaStr = "";
        metaStr += "Filetype: " + dataset.Type + "<br/><br/>";
        if (metaObj.date_created)
            metaStr += "Date: " + metaObj.date_created + "<br/>";
        
        this.setState({ metadata: { __html: metaStr } });*/
        //this.props.handleSelect(dataset);
    }
    handleDownloadEditedFile() {
        var blob = this.uploader.state.file;
        console.log(blob);
        var filename = blob.name.split('.csv')[0] + "_edited" + ".csv";
        FS.saveAs(blob,filename);
    }
    handleLoadClicked(id) {
        var dataset = this.props.datasets.find( f=> f.Id == id);
        console.log('load clicked');
        this.props.handleLoadDataset(dataset);
        //this.props.dispatch(GeoserverActions.downloadDataset(dataset));
    }
    handleDeleteClick(id) {
        this.props.handleDelete(id);
        //this.setState({ dialogOpen: true, deletingID: id });
    }
    handleDeleteConfirm(evt) {
        this.props.dispatch(CmsActions.deleteDataset(this.state.deletingID));
    }
    handleDeleteClose() {
        this.setState({ dialogOpen: false, deletingID: null });
    }
    handleReset(evt) {
        //this.uploader.resetUpload();
        this.setState({ uploadSuccess: false, datasetTitle: "", disabled: false, });
    }
    setError = (err) => {
        this.props.dispatch(CmsActions.setError(err));
    }
    filterDatasetList(evt) {
        let updatedList = this.props.datasets;
        updatedList = updatedList.filter(function (item) {
            return item.Title.toLowerCase().search(
                evt.toLowerCase()) !== -1;
        });
        this.setState({ filteredList: updatedList });
    }
    handleMakeVisClick = (evt) => {
        //TODO: Change app state to Vis
        this.props.dispatch(CmsActions.changeAppState(CmsActions.APP_STATES.VISUALISATION));
    }
    render() {
        const { fetching, fetchingModels, fetchingModelTypes, fetched, datasets = [] } = this.props;
        return (
            <>
                <Grid container spacing={24} justify="center">
                    <Grid item xs={5}>
                        <h2>My Datasets</h2>
                    </Grid>
                    <Grid item xs={7}>
                        {/*<SearchBar
                            onChange={this.filterDatasetList.bind(this)}
                            onRequestSearch={() => console.log('onRequestSearch')}
                            style={{
                                margin: '0 auto',
                                maxWidth: '100%',
                                fontSize: '0.875rem',
                                margin: 'auto 0.875rem',
                                height: '2rem',
                                iconButtonSearch: {
                                    style: {
                                        height: '2.25rem'
                                    }
                                },
                                iconButtonClose: {
                                    style: {
                                        height: '2.25rem'
                                    }
                                }
                            }}
                        />*/}
                    </Grid>
                    <Grid item xs={12} className={this.classes.dataList}>
                        <DatasetList 
                                datasets={this.state.filteredList} 
                                handleSelect={this.handleSelect.bind(this)} 
                                loadClicked={this.handleLoadClicked.bind(this)} 
                                deleteClicked={this.handleDeleteClick.bind(this)} 
                            />
                    </Grid>
                </Grid>
                
                {
                /*<Dialog open={this.state.dialogOpen} onClose={this.handleRequestClose}>
                    <DialogTitle>{"Are you sure you want to delete this dataset?"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleDeleteClose.bind(this)} color="default" disabled={this.state.deleting}>Cancel</Button>
                        <Button onClick={this.handleDeleteConfirm.bind(this)} color="primary" disabled={this.state.deleting}>Delete</Button>
                    </DialogActions>
                    {this.state.deleting ? <LinearProgress /> : null}
                </Dialog>*/
                }
            </>
        );
    }
}
/*
const mapStateToProps = (store) => {
    return {
        visTypes: store.cmsReducers.visTypes,
        userId: store.cmsReducers.userId,
        fetched: store.cmsReducers.fetched,
        fetching: store.cmsReducers.fetchingDatasets,
        datasets: store.cmsReducers.datasets,
        fetchingModels:store.cmsReducers.fetchingModels,
        fetchingModelTypes: store.cmsReducers.fetchingModelTypes,
        modelTypes: store.cmsReducers.modelTypes,
        models:store.cmsReducers.models,
        running: store.cmsReducers.running,
        submitting: store.cmsReducers.uploading,
        uploadSuccessId: store.cmsReducers.uploadSuccessId,
        uploadError: store.cmsReducers.error,
        deleting: store.cmsReducers.deleting,
        processedSitesFile: store.GlobeReducers.processedSitesFile,
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Object.assign({}, CmsActions, GeoserverActions, GlobeActions), dispatch)
});*/
//module.exports = connect(mapStateToProps)(withStyles(styles)(Datasets));
//module.exports = (withStyles(styles)(Datasets));